
import { defineComponent } from 'vue';

export default defineComponent({
    emits: ['cycleLeft', 'cycleRight'],
    props: {
        currentIndex: {
            type: Number,
            required: true,
        },
        totalItems: {
            type: Number,
            required: true,
        },
    },
});
